module.exports = __webpack_public_path__ + "b99921890e4e0e7f45e34f20433ae4bb.jpg";